import React from 'react';
import { isHauptadmin, getInfoValue, CheckRecht } from '../../lib/globalData';
import { useRecordContext, useListContext, Pagination, List, Datagrid, 
  TextField, DateField, ReferenceField, NumberField, DeleteButton, TextInput, BooleanInput }  from 'react-admin';


const listFilter = [
  <TextInput source="res_nr" alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />,
];

const TimezoneDateField = (props) => {
  const record = useRecordContext();
  if(!record?.htz)return (<div>Time zone not set</div>)
  return (
    <DateField {...props} source="datum" label="Hostel time" showTime locales="de-CH" options={{ timeZone: record?.htz, timeZoneName:'shortOffset' }} />
  )
}

const CommentField = () => {
  const record = useRecordContext()
  if(!record || !record.bemerkung)return
  const comment = record.bemerkung.split('\n')
  return (
    <div>
      { comment.map((b, idx) => <div key={record.id+idx}>{b}</div>) }
    </div>
  )
}

const CustomPagination = () => {
  const { page, perPage, setPage, total } = useListContext();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
      <Pagination page={page} perPage={perPage} setPage={setPage} total={total} rowsPerPageOptions={[5,10,25,50,100,500]} />
    </div>
  );
};

const ListForm = (props) => {
  const currency = getInfoValue('currency')
  const filter = [...listFilter]
  if(isHauptadmin())filter.push(<BooleanInput source="showall" alwaysOn />)
  return (
    <List filters={filter} sort={{ field: 'datum', order: 'DESC' }} 
      pagination={<CustomPagination />} perPage={50} empty={false} 
    >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false}
      rowSx={() => ({ verticalAlign: 'top', '& .MuiTableCell-root': { pt: '.6em'} })} >
        <DateField source="datum" showTime locales="de-CH" options={{ timeZoneName:'shortOffset' }} />
        <TimezoneDateField source="datum" label="resources.repHistory.fields.hosteltime" />
        <TextField source="res_nr" />
        <ReferenceField source="id_zahlungsart" reference="setPaymenttype" link={false} >
          <TextField source="bezeichnung" />
        </ReferenceField>
        <TextField source="text" />
        <NumberField source="betrag" options={{ style: 'currency', currency: currency }} />
        <CheckRecht route="setPaymentapp" level={5} label="comment">
          <CommentField label="comment" />
        </CheckRecht>
      {isHauptadmin() &&
        <TextField source="id" textAlign="right" />
      }
        <DeleteButton mutationOptions={{ mutationMode: 'undoable' }} sx={{  mt: '-.25em' }} />
      </Datagrid>
    </List>
  )
}

const SetPayment = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} />
  )
}
export default SetPayment